import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

/**
 * API Service for Basketball Player Directory
 * Connects to the Express backend
 */

class ApiService {
  constructor() {
    this.api = axios.create({
      baseURL: API_BASE_URL,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  /**
   * Get all players
   */
  async getAllPlayers() {
    try {
      const response = await this.api.get('/players');
      return response.data;
    } catch (error) {
      console.error('Error fetching players:', error);
      throw error;
    }
  }

  /**
   * Get single player by ID
   */
  async getPlayer(playerId) {
    try {
      const response = await this.api.get(`/players/${playerId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching player ${playerId}:`, error);
      throw error;
    }
  }

  /**
   * Get player's games
   */
  async getPlayerGames(playerId) {
    try {
      const response = await this.api.get(`/players/${playerId}/games`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching games for ${playerId}:`, error);
      throw error;
    }
  }

  /**
   * Get player's aggregate stats
   */
  async getPlayerStats(playerId) {
    try {
      const response = await this.api.get(`/players/${playerId}/stats`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching stats for ${playerId}:`, error);
      throw error;
    }
  }

  /**
   * Get badge information
   */
  async getBadges() {
    try {
      const response = await this.api.get('/games/badges');
      return response.data;
    } catch (error) {
      console.error('Error fetching badges:', error);
      throw error;
    }
  }

  /**
   * Get rankings
   */
  async getRankings() {
    try {
      const response = await this.api.get('/games/rankings');
      return response.data;
    } catch (error) {
      console.error('Error fetching rankings:', error);
      throw error;
    }
  }

  /**
   * Helper: Get badge image URL
   */
  getBadgeImageUrl(badgeId) {
    return `${API_BASE_URL.replace('/api', '')}/badges/${badgeId}.png`;
  }

  /**
   * Helper: Get player photo URL
   */
  getPlayerPhotoUrl(photoUrl) {
    if (!photoUrl) return null;
    if (photoUrl.startsWith('http')) return photoUrl;
    return `${API_BASE_URL.replace('/api', '')}/photos/${photoUrl}`;
  }
}

export default new ApiService();
